// Libellés français : clés feedbacks_* de Faast (préfixe retiré) et
// libellés que Faast écrivait en dur. Source des clés (MessageKey).
export const fr = {
  action_failed: "L'action a échoué : réessaie.",
  admin_filters: "Pilotage",
  agent_approval_remove: "Retirer la validation agent",
  agent_approval_set: "À traiter par l'agent",
  agent_blocked: "Agent : bloqué {detail}",
  agent_capacity: " · capacité {pct} %",
  agent_idle: "Agent : en veille, file vide",
  agent_limited: "Agent : limite d'usage atteinte, reprise vers {time}",
  agent_no_signal: "Agent : aucun signe de vie publié",
  agent_route_farm: "Ferme d'agents",
  agent_route_title: "À traiter par…",
  agent_route_tower: "Tour de contrôle",
  agent_stale: "Agent : sans nouvelles (dernier signe à {time}), limite d'usage probable",
  agent_will_handle: "Sera traité par l'agent",
  agent_working: "Agent : au travail {detail} · {queue} en file",
  anonymous: "Anonyme",
  archive: "Archiver",
  archive_view_active: "Actifs",
  archive_view_all: "Tous",
  archive_view_archived: "Archivés",
  archive_view_aria: "Vue archive des retours",
  archived: "Archivé",
  business_context: "Contexte",
  cancel: "Annuler",
  close: "Fermer",
  comment_delete_message: "Supprimer ce commentaire ?",
  comment_delete_title: "Supprimer le commentaire",
  comment_mention_none: "Personne à mentionner",
  comment_mention_title: "Mentionner quelqu'un",
  comment_mentioned_label: "Mentionnés : {names}",
  comment_reaction: "Réaction",
  comment_reply: "Répondre",
  comment_reply_count_one: "{count} réponse",
  comment_reply_count_other: "{count} réponses",
  comment_reply_hide: "Masquer les réponses",
  comment_reply_placeholder: "Répondre… (⌘↵ pour envoyer)",
  comment_voice_tooltip: "Dicté à Mila, l'agent vocal",
  comment_edited: "(modifié)",
  comment_failed: "Le commentaire n'est pas passé : réessaie.",
  comment_placeholder: "Répondre… (⌘↵ pour envoyer)",
  comment_placeholder_first: "Écrivez le premier commentaire… (⌘↵ pour envoyer)",
  comment_send: "Envoyer",
  comments_title: "Commentaires",
  composer_add_title: "Ajouter un titre",
  composer_body_aria: "Description",
  composer_body_placeholder: "Détails (optionnel) - markdown supporté",
  composer_body_placeholder_feature: "Décris ton idée…",
  composer_cancel: "Annuler",
  composer_cancel_confirm: "Annuler ce brouillon ?",
  composer_cancel_title: "Annuler le brouillon",
  composer_cancel_yes: "Oui, annuler",
  composer_continue: "Continuer",
  composer_save: "Enregistrer",
  composer_saved: "Enregistré",
  composer_saving: "Enregistrement…",
  composer_submit: "Envoyer mon feedback",
  composer_submit_failed: "Envoi échoué - réessaie.",
  composer_submit_sending: "Envoi…",
  composer_submit_sent: "Envoyé",
  composer_title_aria: "Titre du feedback",
  composer_title_placeholder: "Titre du retour",
  composer_title_placeholder_bug: "Que s’est-il passé ?",
  composer_title_placeholder_feature: "Décris ton idée en une phrase…",
  composer_title_placeholder_question: "Quelle est ta question ?",
  composer_update_failed: "Modification échouée : réessaie.",
  confirm: "Confirmer",
  context_capture: "Capture",
  context_console_errors: "Erreurs console ({count})",
  context_console_include: "Inclure les {count} erreurs console récentes",
  context_no_capture: "Aucune",
  context_screenshot_alt: "Capture d'écran",
  context_screenshot_open: "Ouvrir la capture en plein écran",
  context_title: "Contexte technique",
  context_url: "URL",
  context_user_agent: "User-agent",
  context_viewport: "Viewport",
  delete: "Supprimer",
  delete_message: "Supprimer ce retour ? Un administrateur pourra le restaurer.",
  delete_title: "Supprimer le retour",
  detail_discussion_label: "Discussion",
  duplicate_of: "Doublon de",
  edit: "Modifier",
  empty_detail: "Sélectionne un feedback dans la liste pour voir le détail.",
  empty_detail_v2: "Sélectionne un élément",
  empty_filtered_clear: "Tout effacer",
  empty_filtered_inline: "Rien trouvé.",
  empty_filtered_subtitle: "Essaie de retirer des filtres ou élargir la recherche.",
  empty_filtered_title: "Aucun feedback ne correspond",
  empty_first_cta: "Créer un feedback",
  empty_first_cta_bug: "Bug",
  empty_first_cta_bug_aria: "Signaler un bug",
  empty_first_cta_idea: "Idée",
  empty_first_cta_idea_aria: "Créer une nouvelle idée",
  empty_first_cta_question: "Question",
  empty_first_cta_question_aria: "Poser une question",
  empty_first_shortcut_hint: "Tu peux aussi appuyer sur ⌘ + Maj + F partout sur ce site",
  empty_first_subtitle: "Idées, bugs ou questions - on lit tout.",
  empty_first_subtitle_v2: "Partage une idée, un bug rencontré ou une question. L'équipe lit chaque message envoyé.",
  empty_first_title: "Sois le premier à donner ton avis ✨",
  empty_first_title_v2: "Lance la conversation",
  filter_all: "Tout",
  filter_all_authors: "Tous les auteurs",
  filter_author: "Auteur",
  filter_mine: "Mes feedbacks uniquement",
  filter_others: "Des autres",
  filter_search_aria: "Rechercher dans les feedbacks",
  filter_search_clear: "Effacer la recherche",
  filter_search_placeholder: "Rechercher (3 caractères min.)…",
  filter_status_aria: "Filtrer par statut",
  filter_trash: "Corbeille",
  filter_type_aria: "Filtrer par type",
  filter_unread: "Non lus",
  filters_region_aria: "Filtres",
  filters_reset: "Réinitialiser",
  filters_toggle: "Filtres",
  handled_by_tower: "Pris en charge par la tour",
  history_count: "{count} modification(s)",
  history_open: "Voir l'historique des modifications",
  history_replaced_on: "Version remplacée le {date}",
  history_title: "Historique des modifications",
  load_error: "Erreur de chargement",
  load_more: "Charger plus",
  loading: "Chargement…",
  media_add: "Ajouter un média",
  media_add_button: "Ajouter un média",
  media_attached_count: "{count} pièce(s) jointe(s)",
  media_close_lightbox: "Fermer",
  media_dismiss_error: "Masquer l'erreur",
  media_drop_hint: "ou glisser-déposer",
  media_max_reached: "Maximum {max} fichiers",
  media_open_lightbox: "Ouvrir en plein écran",
  media_open_original: "Ouvrir l'original",
  media_open_pdf: "Ouvrir le PDF",
  media_remove: "Retirer ce média",
  media_too_large: "{name} dépasse la taille max de 10 Mo.",
  media_unsupported_type: "Type non supporté : {type}",
  media_upload_failed: "Upload échoué - réessaie.",
  media_uploading: "Upload de {name}…",
  modal_back: "Retour",
  modal_close: "Fermer",
  modal_filters_active_aria: "Filtres actifs",
  modal_new: "Nouveau",
  modal_new_aria: "Nouveau feedback",
  modal_title: "Feedbacks",
  next: "Suivant",
  not_found: "Feedback introuvable",
  preview_close: "Fermer l'aperçu",
  preview_title: "Retour déjà déposé",
  previous: "Précédent",
  relative_now: "à l’instant",
  retry: "Réessayer",
  save: "Enregistrer",
  screenshot_attach: "Joindre une capture",
  screenshot_attached_alt: "Capture d'écran jointe",
  screenshot_capturing: "Capture…",
  screenshot_failed: "Capture échouée",
  screenshot_remove: "Retirer la capture",
  screenshot_target_missing: "Élément cible introuvable.",
  screenshot_view: "Voir la capture en plein écran",
  search_toggle: "Rechercher",
  similar_aria: "Feedbacks similaires",
  similar_declined: "écarté {since}",
  similar_duplicate: "doublon {since}",
  similar_posted: "posé {since}",
  similar_shipped: "livré {since}",
  similar_title: "Existe déjà ?",
  sort_aria: "Tri des retours",
  sort_comments: "Commentés",
  sort_recent: "Récents",
  sort_score: "Votes",
  sort_updated: "Mis à jour",
  source_academy: "Academy",
  source_ai: "IA",
  source_caast: "Synchronisation Caast",
  source_cli: "Ligne de commande",
  source_mcp: "MCP",
  source_phone: "Dicté au téléphone",
  source_voice: "Dicté",
  status_active: "Actifs",
  status_change_aria: "Statut : {label}, modifier",
  status_declined: "Refusé",
  status_duplicate: "Doublon",
  status_in_progress: "En cours",
  status_on_hold: "Au frigo",
  status_open: "Ouvert",
  status_planned: "Planifié",
  status_shipped: "Livré",
  status_under_review: "Sous revue",
  trigger_aria_open: "Ouvrir Feedbacks",
  trigger_aria_open_desktop: "Ouvrir Feedbacks (raccourci ⌘+Shift+F)",
  trigger_unread: "Ouvrir les retours : {count} non lu(s)",
  type_bug: "Bug",
  type_bug_hint: "Quelque chose ne va pas",
  type_bugs: "Bugs",
  type_feature: "Idée",
  type_feature_hint: "Nouvelle fonctionnalité",
  type_features: "Idées",
  type_legend: "Type de feedback",
  type_question: "Question",
  type_question_hint: "J'ai un doute",
  type_questions: "Questions",
  unarchive: "Désarchiver",
  unread: "Non lu",
  unread_comments: "Commentaires non lus",
  vote_down: "Voter contre",
  vote_down_remove: "Retirer mon vote négatif",
  vote_failed: "Le vote n'est pas passé : réessaie.",
  vote_up: "Voter pour",
  vote_up_remove: "Retirer mon vote positif",
  typing_many: "{names} écrivent…",
  typing_one: "{name} écrit…",
}
